import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconOnaFolder: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M10.8334 3.83333H13.5V7.16667M13.5 7.16667H14.1667V13.5H1.83337V5.16667H2.50004M13.5 7.16667H10.8334M2.50004 5.16667V2.5H10.8334V7.16667M2.50004 5.16667H5.83337L7.83337 7.16667H10.8334"
                        stroke="currentColor"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="translate(2,2)">
                        <path
                            d="M10.8334 3.83333H13.5V7.16667M13.5 7.16667H14.1667V13.5H1.83337V5.16667H2.50004M13.5 7.16667H10.8334M2.50004 5.16667V2.5H10.8334V7.16667M2.50004 5.16667H5.83337L7.83337 7.16667H10.8334"
                            stroke="currentColor"
                        />
                    </g>
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="translate(4,4)">
                        <path
                            d="M10.8334 3.83333H13.5V7.16667M13.5 7.16667H14.1667V13.5H1.83337V5.16667H2.50004M13.5 7.16667H10.8334M2.50004 5.16667V2.5H10.8334V7.16667M2.50004 5.16667H5.83337L7.83337 7.16667H10.8334"
                            stroke="currentColor"
                        />
                    </g>
                </svg>
            );
    }
};
